import React from "react"
import { Helmet } from "react-helmet"
import useSiteMetadata from "../hooks/useSiteMetadata";
import { useLocation } from '@reach/router';

const Twitter = ({ type = "summary_large_image", username, title, desc, image }) => (
  <Helmet>
    <meta name="twitter:card" content={type} />
    {username && <meta name="twitter:creator" content={username} />}
    {title && <meta name="twitter:title" content={title} />}
    {desc && <meta name="twitter:description" content={desc} />}
    {image && <meta name="twitter:image" content={image} />}
  </Helmet>
);

const Facebook = ({ url, type, title, desc, image }) => (
  <Helmet>
    {url && <meta property="og:url" content={url} />}
    {type && <meta property="og:type" content={type} />}
    {title && <meta property="og:title" content={title} />}
    {desc && <meta property="og:description" content={desc} />}
    {image && <meta property="og:image" content={image} />}
  </Helmet>
);

const Seo = ({ title, description = null, image = null, index = true, pathname }) => {
  const metadata = useSiteMetadata();
  const location = useLocation();
  const seo = {
    description: description || metadata.description,
    image: `${metadata.siteUrl}${image || metadata.logo}`,
    title: title || metadata.title,
    url: `${metadata.siteUrl}${location.pathname}`
  };

  return (
    <>
      <Helmet title={seo.title} titleTemplate={seo.title === metadata.title ? "%s" : metadata.titleTemplate}>
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
        <meta name="robots" content={index ? "all" : "noindex"} />
        <html lang="en" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Facebook title={seo.title} desc={seo.description} image={seo.image} url={seo.url} type={null} />
      <Twitter title={seo.title} desc={seo.description} image={seo.image} username={metadata.twitter} />
    </>
  );
}

export default Seo;
